var swiper = new Swiper.default('.swiper-container', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }

});



// WEBPACK FOOTER //
// ./resources/assets/js/ui/swiper_init.js